import {Component} from '@angular/core';
import {NavController, NavParams, AlertController} from 'ionic-angular';
import {Ask} from '../../models/ask';
import {Product} from '../../models/product';
import {DataProvider} from '../../providers/data';

/**
 * Generated class for the AskPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ask',
    templateUrl: 'ask.html',
})
export class AskPage {
    public curCountry: string;
    public currentQuestion: Ask = new Ask();
    public products: Product[] = [];
    public productId: number;
    //public filteredProducts: Product[] = [];

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public alertCtrl: AlertController,
                private dataService: DataProvider) {
        this.curCountry = dataService.CURRENT_COUNTRY;
    }

    ionViewDidLoad() {
        // if (this.productId) {
        //     currentQuestion.
        // }
        console.log('ionViewDidLoad AskPage');
        this.dataService.getProducts()
            .subscribe(productsData => {
                this.products = productsData.sort(function (prod1, prod2) {
                    let name1 = prod1.name.toLowerCase();
                    let name2 = prod2.name.toLowerCase();
                    if (name1 < name2) return -1;
                    if (name1 > name2) return 1;
                    return 0;
                });
                //this.filteredProducts = this.products;
            });
    }

    ionViewDidEnter() {
        this.currentQuestion.product_id = this.dataService.PRODUCT_ID_FOR_ASK;// +navParams.get('product_id');
    }

    public sendQuestion(e: any) {
        let mainThis = this;
        let emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.currentQuestion.question || this.currentQuestion.question.length < 10) {
            let alert = this.alertCtrl.create({
                title: 'Info',
                message: 'Please enter a question at least 10 characters long.',
                buttons: [
                    {
                        text: 'OK',
                        handler: () => {
                        }
                    }
                ]
            });
            alert.present();
        }
        else if (!this.currentQuestion.email || !emailRE.test(this.currentQuestion.email)) {
            let alert = this.alertCtrl.create({
                title: 'Info',
                message: 'Please enter a correct email.',
                buttons: [
                    {
                        text: 'OK',
                        handler: () => {
                        }
                    }
                ]
            });
            alert.present();
        }
        else {
            let alert = this.alertCtrl.create({
                title: 'Info',
                message: 'Your question was successfully sent.',
                buttons: [
                    {
                        text: 'OK',
                        handler: () => {
                            mainThis.currentQuestion.product_id = 0;
                            mainThis.currentQuestion.email = '';
                            mainThis.currentQuestion.question = '';
                        }
                    }
                ]
            });
            alert.present();
        }
    }

    // public filterProducts(e: any) {
    //     let val = e.target.value;

    //     if (val && val.trim() !== '') {
    //         this.filteredProducts = this.products.filter(function (item) {
    //             return item.name.toLowerCase().includes(val.toLowerCase());
    //         });
    //     }
    //     else {
    //         this.filteredProducts = this.products;
    //     }
    // }
}



// WEBPACK FOOTER //
// ./src/pages/ask/ask.ts